import React from 'react';

import BoxPlotComponent from './Component';

const MIN_BOX_PLOT_HEIGHT = 500;

class BoxPlotContainer extends React.PureComponent {
  constructor (props) {
    super(props);

    this.state = {
      canvasWidth: 0,
      canvasHeight: 0
    };

    this.captureContainerProps = container => {
      if (container) {
        const canvasWidth = container.clientWidth;

        const canvasHeight = Math.max(
          container.clientHeight,
          MIN_BOX_PLOT_HEIGHT
        );

        this.setState({ canvasWidth, canvasHeight });
      }
    };
  }

  render () {
    return (
      <div ref={this.captureContainerProps} className="flex flex-grow">
        {this.state.canvasWidth && this.state.canvasHeight &&
          <BoxPlotComponent {...this.props} {...this.state} />
        }
      </div>
    );
  }
}

export default BoxPlotContainer;
